import { Component, OnDestroy } from '@angular/core';
import { NJReadDocDefTemplateLookup } from "../../DOData";

@Component({
    selector: 'checkbox-renderer',
    templateUrl: './checkbox-cell-rending.component.html',
    styleUrls: ['./checkbox-cell-rending.component.css']
})
export class CheckboxRendererComponent {//implements ICellRendererAnularComp, OnDestroy {
    //refresh(params: ICellRendererParams): boolean {
    //    //throw new Error("Method not implemented.");
    //    return true;
    //}
    //afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    //    //throw new Error("Method not implemented.");
    //}
    private lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup> = new Array<NJReadDocDefTemplateLookup>();
    ngOnDestroy(): void {
        //throw new Error("Method not implemented.");
    }
    public params: any;
    private LookupId: number;
    public isDisabled: boolean;
    agInit(params: any): void {
        this.params = params;

        // disable the check box based on 
        // a text box column 
        if (this.params.template.dictCustomParameters.disableByTextBoxBlank) {
            if (this.params.value < 0) {
                this.isDisabled = true;
                this.params.value = Math.abs(this.params.value);
            }
            else
                this.isDisabled = false;
        }
        else {
            this.isDisabled = this.params.isDisabled;
        }

        if (this.params.value != undefined && this.params.value != true && this.params.value !== false && this.params.value != '') {
            if (this.params.template.lookupTypeId == 0) {
                this.params.value = this.params.value == '1';
            } else {
                this.LookupId = this.params.value;

                this.lstDocDefTemplateLookup = this.params.lstDocDefTemplateLookup || null;
                if (this.params.template.lookupTypeId > 0) {
                    for (var i = 0; i < this.lstDocDefTemplateLookup.length; i++) {
                        if (this.lstDocDefTemplateLookup[i].lookupId == this.LookupId) {
                            this.params.value = (this.lstDocDefTemplateLookup[i].shortDesc == "Y")
                        }
                    }
                }
            }
        }

        
    }

    

    checkedHandler(event) {
        let checked = event.target.checked;
        let colId = this.params.column.colId;
        this.params.node.setDataValue(colId, checked);

        this.params.onClick(this.params);
    }
}
